import React, { useEffect, useState } from 'react'
import { approveOrRejectSiteBoqApi, getAllSiteBoqApi, getSiteContractApi, removeBoqByIdApi, saveSiteContractApi } from '../../utils/ApiEndpointFunctions';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Spinwheel from '../../components/common/Spinwheel';
import { useUserContext } from '../../context/userContext';
import toast from 'react-hot-toast';
import ConfirmationModal from '../../components/modal/ConfirmationModal';
import Filter from '../../components/modal/Filter';
import { useFormik } from 'formik';
import moment from 'moment/moment';
import ReactPaginate from 'react-paginate';
import { getLocalizationStatus } from '../../utils/HelperFuncitons';
import StatusModal from '../../components/modal/StatusModal';

const formatBoqCurrency = (value) => `₹ ${Number(value || 0).toLocaleString("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;

const emptyContract = {
  contractDate: "",
  contractStartDate: "",
  completionDate: "",
  actualDate: "",
  extendedCompletionDate: "",
  incDesc: 0,
  taxType: "gst",
  tax: 0,
};

const toDateInput = (value) => value ? moment(value).format("YYYY-MM-DD") : "";
const displayDate = (value) => value ? moment(value).format("DD/MM/YYYY") : "-";

export default function ViewAllBoq(props) {
  const [boq, setBoq] = useState([])
  const [loading, setLoading] = useState({ boq: true })
  const navigate = useNavigate();
  const { userDetails,langPreference} = useUserContext();
  const confirmModalId = "conFirmModalID"
  const deleteConfirmModalId = "deleteBoqConfirmModalID"
  const filterModalId = "filterModalID"
  const statusModalId = "statusModal"
  const siteContractModalId = "siteContractModalId"
  const [selectBoq, setSelectedBoq] = useState({id:null,boqNo:null,status:null});
  const limit = 10;
  const [page, setPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  // let [selectedPage, setSelectedPage] = useState(searchParams.get("page") == null ? 1 : searchParams.get("page"));
  const canDeleteBoq = (status = "") => ["created", "submitted"].includes(String(status).toLowerCase());

  const [totalCount, setTotalCount] = useState(null);
  const [siteContract, setSiteContract] = useState(null);
  const [siteSummary, setSiteSummary] = useState({});
  const [contractForm, setContractForm] = useState(emptyContract);
  const [contractLoading, setContractLoading] = useState(true);
  const [contractSaving, setContractSaving] = useState(false);

  const getSiteContract = async ({ showError = true } = {}) => {
    setContractLoading(true);
    try {
      const res = await getSiteContractApi();
      if (res.status === 200) {
        const contract = res.data?.data?.contract || null;
        setSiteContract(contract);
        setSiteSummary(res.data?.data?.summary || {});
        return contract;
      }
      return null;
    } catch (error) {
      if (showError) {
        toast.error(error?.response?.data?.message || "Unable to load site contract details.");
      }
      return null;
    } finally {
      setContractLoading(false);
    }
  };

  const openContractForm = () => {
    setContractForm(siteContract ? {
      contractDate: toDateInput(siteContract.contractDate),
      contractStartDate: toDateInput(siteContract.contractStartDate),
      completionDate: toDateInput(siteContract.completionDate),
      actualDate: toDateInput(siteContract.actualDate),
      extendedCompletionDate: toDateInput(siteContract.extendedCompletionDate),
      incDesc: siteContract.incDesc ?? 0,
      taxType: siteContract.taxType || "gst",
      tax: siteContract.tax ?? 0,
    } : emptyContract);
  };

  const updateContractField = (event) => {
    const { name, value } = event.target;
    setContractForm((current) => ({ ...current, [name]: value }));
  };

  const saveSiteContract = async () => {
    const required = ["contractDate", "contractStartDate", "completionDate", "actualDate", "taxType"];
    if (required.some((field) => !contractForm[field])) {
      toast.error("Please fill all required contract details.");
      return;
    }
    setContractSaving(true);
    try {
      const res = await saveSiteContractApi(contractForm);
      if (res.status === 200) {
        const savedContract = res.data?.data?.contract;
        if (!savedContract) {
          throw new Error("Site contract was not returned after saving.");
        }
        setSiteContract(savedContract);
        setSiteSummary(res.data?.data?.summary || {});
        const persistedContract = await getSiteContract({ showError: false });
        if (!persistedContract) {
          throw new Error("Site contract could not be loaded after saving.");
        }
        document.getElementById("siteContractModalClose")?.click();
        toast.success(res.data?.message || "Site contract details saved.");
        getAllDprList();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Unable to save site contract details.");
    } finally {
      setContractSaving(false);
    }
  };

  const getAllDprList = async (filterReset) => {
    setLoading({ ...loading, boq: true });
    let filter = filterReset === "reset" ? ["", "", "", "", "", ""] : [
      filterFormik.values?.itemId,
      `${filterFormik.values?.to ? new Date(filterFormik.values?.to).getTime() + "-" : ""}${filterFormik.values?.from ? new Date(filterFormik.values?.from).getTime() : ""}`,
      filterFormik.values?.hsnCode,
      filterFormik.values?.number,
      filterFormik.values?.status,
      filterFormik.values?.vendorName,
    ];
    try {
      const page = searchParams.get("page") || 1
      const res = await getAllSiteBoqApi(...filter, limit, page);
      if (res.status === 200) {
        setBoq(res.data?.data?.boq);
        setTotalCount(res.data?.data?.totalCount);
        setPage(Math.ceil(res.data?.data?.totalCount / limit));
      }
    } catch (error) {
      console.log(error)
    }
    setLoading({ ...loading, boq: false });
  }

  const handlePageClick = (event) => {
    let currentPage = event.selected + 1;

    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", currentPage);

    if (newParams.has("tab")) {
      newParams.set("tab", newParams.get("tab"));
    }

    setSearchParams(newParams);
  };


  const handleApproval = async () => {
    try {
      const res = await approveOrRejectSiteBoqApi({ id: selectBoq.id,status:selectBoq?.status })
      if (res.status === 200) {
        toast.success(res.data?.message)
        document.getElementById(confirmModalId).click()
        document.getElementById("statusModalBtn").click()
        getAllDprList()
      }
    } catch (error) {
      console.log(error)
      toast.error("something went wrong");
    }
  }

  const handleDeleteBoq = async () => {
    try {
      const res = await removeBoqByIdApi(selectBoq?.id)
      if (res.status === 200) {
        toast.success(res.data?.message)
        document.getElementById(deleteConfirmModalId)?.click()
        document.getElementById("statusModalBtn").click()
        getAllDprList()
        getSiteContract()
      }
    } catch (error) {
      console.log(error)
      error && error.response ?
        toast.error(error.response?.data?.message) :
        toast.error("something went wrong");
    }
  }


  const handleFilterPo = () => {
    if (searchParams.get('page') == 1) {
      getAllDprList()
    } else {
      setSearchParams({ "page": 1 })
    }
  }

  const filterFormik = useFormik({
    initialValues: {
      Item: "",
      hsnCode: "",
      number: "",
      status: "",
      vendorName: "",
      to: "",
      from: "",
      itemId:""
    }
  })


  useEffect(() => {
      getAllDprList()
  },[searchParams.get('page')])

  useEffect(() => {
    if (props.type !== "dashboard") getSiteContract();
  }, [])

  return (
    <>

      <div className="main-content">
        <div className="container-fluid">
          <div className="row">
            <div className="main-content">

              {props.type !== "dashboard" && <div className="dash-nav1">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="mb-0 font-blue">{langPreference?.contract_management || "Contract Management"}</h3>
                </div>
              </div>}
              {props.type !== "dashboard" && (
                <div className="border rounded p-3 mb-3 bg-white">
                  {contractLoading ? (
                    <div className="d-flex justify-content-center py-3"><Spinwheel /></div>
                  ) : siteContract ? (
                    <div className="position-relative">
                      {userDetails?.roleId?.permission?.includes("boqUpdate") && (
                          <button type="button" className="add-vendor mb-0 position-absolute end-0" style={{top:"10px"}} data-bs-toggle="modal" data-bs-target={`#${siteContractModalId}`} onClick={openContractForm}>
                            {langPreference?.edit || "Edit"}
                          </button>
                      )}
                      <div className="row g-3 mb-3" style={{paddingRight: userDetails?.roleId?.permission?.includes("boqUpdate") ? "90px" : 0}}>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.contract_date || "Contract Date"}</strong><div>{displayDate(siteContract.contractDate)}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.date_of_start_contract || "Contract Start Date"}</strong><div>{displayDate(siteContract.contractStartDate)}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.date_of_completion_contract || "Completion Date"}</strong><div>{displayDate(siteContract.completionDate)}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.extended_completion_date || "Extended Completion Date"}</strong><div>{displayDate(siteContract.extendedCompletionDate)}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.date_of_start_actual || "Actual Start Date"}</strong><div>{displayDate(siteContract.actualDate)}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.incr_decr || "Incr/Decr"} (%)</strong><div>{siteContract.incDesc ?? 0}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.tax_type || "Tax Type"}</strong><div className="text-uppercase">{siteContract.taxType || "-"}</div></div>
                        <div className="col-6 col-lg-3"><strong>{langPreference?.tax || "Tax"} (%)</strong><div>{siteContract.tax ?? 0}</div></div>
                      </div>
                      <div className="row row-cols-2 row-cols-md-3 row-cols-xl-5 g-3 border-top mt-2">
                        <div className="col"><div className="d-flex align-items-baseline gap-2 flex-wrap"><strong>BOQs:</strong><span>{siteSummary.boqCount || 0}</span></div></div>
                        <div className="col"><div className="d-flex align-items-baseline gap-2 flex-wrap"><strong>{langPreference?.total_amount || "Total Amount"}:</strong><span>{formatBoqCurrency(siteSummary.amount)}</span></div></div>
                        <div className="col"><div className="d-flex align-items-baseline gap-2 flex-wrap"><strong>{langPreference?.inc_dec_value || "Inc/Dec Value"}:</strong><span>{formatBoqCurrency(siteSummary.incDescValue)}</span></div></div>
                        <div className="col"><div className="d-flex align-items-baseline gap-2 flex-wrap"><strong>{langPreference?.tax_amount || "Tax Amount"}:</strong><span>{formatBoqCurrency(siteSummary.taxAmt)}</span></div></div>
                        <div className="col"><div className="d-flex align-items-baseline gap-2 flex-wrap"><strong>{langPreference?.grand_total || "Grand Total"}:</strong><span>{formatBoqCurrency(siteSummary.grandTotal)}</span></div></div>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex justify-content-between align-items-center gap-3 flex-wrap">
                      <div>
                        <h5 className="font-blue fw-bold mb-1">Site Contract Details</h5>
                        <div className="text-muted">Contract details have not been configured for this site.</div>
                      </div>
                      {userDetails?.roleId?.permission?.includes("boqUpdate") && (
                        <button type="button" className="create-order" data-bs-toggle="modal" data-bs-target={`#${siteContractModalId}`} onClick={openContractForm}>Add Contract Details</button>
                      )}
                    </div>
                  )}
                </div>
              )}
              <div className="d-flex justify-content-end align-items-end">
                <div className="d-flex align-items-center justify-content-end gap-2">
                    {userDetails?.roleId?.permission?.includes("dprWrite") && <button onClick={() => {
                      if (!siteContract) {
                        toast.error("Please add the site contract details before creating a BOQ.");
                        return;
                      }
                      navigate("/boq/add");
                    }} className="create-order">{langPreference?.create_boq || "Create BOQ"}</button>}
                    <button className="btn btn-dark" type="button" disabled={!Object.values(filterFormik?.values).filter(Boolean).length} onClick={() => { filterFormik.resetForm(); getAllDprList("reset") }} >
                      {langPreference?.reset_filter || "Reset filter"}
                    </button>
                    <button className="btn filter  dropdown-toggle" type="button" data-bs-toggle="modal" data-bs-target={`#${filterModalId}`}  >
                      <i className="bi bi-funnel me-2"></i>{langPreference?.filter || "Filter"}
                    </button>
                </div>
              </div>
              {/* <!-- table --> */}
              <div className="table-responsive" style={{ overflowX: "inherit" }}>
                <table className="table d-table mt-4">
                  <thead>
                    <tr>
                      <th scope="col">{langPreference?.boq_number || "BOQ NUMBER"}</th>
                      <th scope="col">{langPreference?.category || "CATEGORY"}</th>
                      <th scope="col">{langPreference?.sub_category || "SUB-CATEGORY"}</th>
                      <th scope="col">{langPreference?.item_counts || "ITEM COUNT"}</th>
                      <th scope="col">{langPreference?.total || "TOTAL"}</th>
                      <th scope="col">{langPreference?.status || "STATUS"}</th>
                      <th scope="col">{langPreference?.action || "ACTION"}</th>
                    </tr>
                  </thead>
                  {
                    loading.boq ?
                      <tbody >
                        <tr>
                          <td colSpan={12}>
                            <div className="d-flex justify-content-center">
                              <Spinwheel />
                            </div>
                          </td>
                        </tr>
                      </tbody> :
                     
                        <tbody>
                          {boq?.length > 0 ? boq?.map((ele, index) => {
                            const isBoqEditable = userDetails?.roleId?.permission.includes("boqUpdate") && ele?.status?.toLowerCase() !== "approved" && ele?.status?.toLowerCase() !== "rejected";
                            return (
                              <tr key={index}>
                                <td>{ele?.boqNumber}</td>
                                <td>{ele?.category || "-"}</td>
                                <td>{ele?.subCategory || "-"}</td>
                                <td>{ele?.itemCount || 0}</td>
                                <td>{formatBoqCurrency(ele?.grandTotal ?? ele?.amount)}</td>
                                <td><button className={` cursor-text text-capitalize ${ele?.status?.toLowerCase() == "approved" ? "approve" : (ele?.status?.toLowerCase() == "rejected" ? "reject" : "sbm")} `}>{getLocalizationStatus(langPreference,ele?.status)}</button></td>
                                <td>
                                  <div className="d-flex justify-content-start align-items-center">
                                    <div>
                                      {userDetails?.roleId?.permission.includes("poReject") && ele?.status?.toLowerCase() !== "reject" && <button className="reject">Reject</button>}
                                    </div>
                                    <div>
                                      <div className="dropdown">
                                        <button className="dots dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="bi bi-three-dots-vertical"></i></button>
                                        <ul className="dropdown-menu">
                                          {userDetails?.roleId?.permission.includes("boqRead") && <li className='dropdown-item' onClick={() => { navigate(`/boq/view/${ele?._id}`) }} >{isBoqEditable ? (langPreference?.view_edit || "View/Edit") : (langPreference?.view || "View")}</li>}
                                          {userDetails?.roleId?.permission.includes("boqUpdate") && canDeleteBoq(ele?.status) &&
                                            <li className='dropdown-item text-danger' data-bs-toggle="modal" data-bs-target={`#${deleteConfirmModalId}`} onClick={() => { setSelectedBoq({id:ele?._id,boqNo:ele?.boqNumber,status:"deleted"}) }} >{langPreference?.delete || "Delete"}</li>}
                                          {userDetails?.roleId?.permission.includes("boqApprove") && ele?.status?.toLowerCase() != "created" && ele?.status?.toLowerCase() != "approved" && ele?.status?.toLowerCase() != "rejected" &&
                                            <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSelectedBoq({id:ele?._id,boqNo:ele?.boqNumber,status:"approved"}) }} >{langPreference?.approve || "Approve"}</li>}
                                            {/* {userDetails?.roleId?.permission.includes("dprDecline") && ele?.status?.toLowerCase() != "created" && ele?.status?.toLowerCase() != "rejected" && <li className='dropdown-item' data-bs-toggle="modal" data-bs-target={`#${confirmModalId}`} onClick={() => { setSelectedBoq({id:ele?._id,boqNo:ele?.boqNumber,status:"rejected"}) }} >Reject</li>} */}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>)
                          }) : <tr className='text-center'>
                            <td colSpan="12">
                              <h1>{langPreference?.data_not_found || "Data Not Found"}</h1>
                            </td>
                          </tr>}
                        </tbody>}
                </table>
              </div>
              {totalCount > limit ? (
                <div className="d-flex justify-content-center">
                  <ReactPaginate
                   nextLabel={`${langPreference?.next_page || "Next"} >`}
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    pageCount={page}
                    previousLabel={`< ${langPreference?.previous_page || "Previous"}>`}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName={"active"}
                    forcePage={searchParams.get('page')? Number(searchParams.get('page'))-1 : 0}
                  />
                </div>
              ) : (
                ""
              )}
              <div className="modal fade" id={siteContractModalId} tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{siteContract ? "Edit" : "Add"} Site Contract Details</h5>
                      <button id="siteContractModalClose" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      <div className="row g-3">
                        {[
                          ["contractDate", langPreference?.contract_date || "Contract Date"],
                          ["contractStartDate", langPreference?.date_of_start_contract || "Date of Start (as per Contract)"],
                          ["completionDate", langPreference?.date_of_completion_contract || "Date of Completion (as per Contract)"],
                          ["extendedCompletionDate", langPreference?.extended_completion_date || "Extended Date of Completion"],
                          ["actualDate", langPreference?.date_of_start_actual || "Date of Start (Actual)"],
                        ].map(([name, label]) => (
                          <div className="col-12 col-md-6" key={name}>
                            <label className="form-label" htmlFor={name}>{label}{name !== "extendedCompletionDate" && <span className="req-error"> *</span>}</label>
                            <input id={name} name={name} type="date" className="form-control" value={contractForm[name]} onChange={updateContractField} />
                          </div>
                        ))}
                        <div className="col-12 col-md-6">
                          <label className="form-label" htmlFor="incDesc">{langPreference?.incr_decr || "Incr/Decr"} (%)</label>
                          <input id="incDesc" name="incDesc" type="number" step="0.01" className="form-control" value={contractForm.incDesc} onChange={updateContractField} />
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label" htmlFor="taxType">{langPreference?.tax_type || "Tax Type"}<span className="req-error"> *</span></label>
                          <select id="taxType" name="taxType" className="form-select" value={contractForm.taxType} onChange={updateContractField}>
                            <option value="gst">GST</option>
                            <option value="igst">IGST</option>
                          </select>
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label" htmlFor="tax">{langPreference?.tax || "Tax"} (%)</label>
                          <input id="tax" name="tax" type="number" min="0" max="100" step="0.01" className="form-control" value={contractForm.tax} onChange={updateContractField} />
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{langPreference?.cancel || "Cancel"}</button>
                      <button type="button" className="save-btn" disabled={contractSaving} onClick={saveSiteContract}>
                        {contractSaving ? <Spinwheel sizeClass="spin-small" /> : (langPreference?.save || "Save")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <ConfirmationModal modalId={confirmModalId} handleConfirm={handleApproval} message={selectBoq?.status=="approved" ? langPreference?.approve_confirmation : langPreference?.confirm_reject} />
              <ConfirmationModal modalId={deleteConfirmModalId} handleConfirm={handleDeleteBoq} message={langPreference?.delete_confirmation || <>Are you sure you want to permanently <br /> delete this BOQ? This cannot be reversed.</>} />
              <Filter modalId={filterModalId} formik={filterFormik} clickHandler={handleFilterPo} filterType={"boq"}/>
              <button className='d-none' id="statusModalBtn" data-bs-toggle="modal" data-bs-target={`#${statusModalId}`}/>
              <StatusModal 
                modalId={statusModalId}
                message={`BOQ ${selectBoq.boqNo || ""} is successfully ${selectBoq?.status}.`}
              />

            </div>
          </div>
        </div>
      </div>
    </>
  )
}
